import React, { useState, useContext, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { CgMenuLeftAlt } from "react-icons/cg";
import { IoClose } from "react-icons/io5";
import {
  ConnectNavigations,
  navigation,
  superAdminNavigation,
} from "../../router/routes";
import { appContext } from "../../context/ContextProvider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import "./Header.css";
import {
  Avatar,
  Box,
  Button,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  LogoutRounded,
  Person2Rounded,
  ListAlt,
  DashboardRounded,
  MedicalServices,
} from "@mui/icons-material";
import { styled, alpha } from "@mui/material/styles";
import { IoMdArrowDropdown } from "react-icons/io";
import LanguageSwitcher from "../LanguageSwitcher";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { List } from "immutable";
import { iconMap } from "../../utils/IconsMap";
import { FaExchangeAlt } from "react-icons/fa";
import axios from "axios";
import { parsePermissions } from "../../pages/auth/Login";
import toast from "react-hot-toast";

function Header({ setSubNav, subNav, isScrolled }) {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [toggle, setToggle] = useState(false);
  const [subMenu, setSubMenu] = useState(null);
  const { setToken, user, setUser, setPermissions } = useContext(appContext);
  const [active, setActive] = useState("Dashboard");
  const [changeLoading, setChangeLoading] = useState(false);
  const [roleNavigation, setRoleNavigation] = useState([]);
  const [users, setUsers] = useState([]);
  const token = localStorage.getItem("token");
  const tokenWithoutQuotes = token?.replace(/"/g, "");

  const fetchUsers = async () => {
    try {
      const response = await axios.get(
        "https://api.supergitsa.com/api/listGroupUsers",
        {
          headers: {
            Authorization: `Bearer ${tokenWithoutQuotes}`,
          },
        },
      );
      const data = response.data;
      if (data?.data) {
        setUsers(data?.data);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);
  useEffect(() => {
    if (user?.RoleId === "12") {
      setRoleNavigation(superAdminNavigation);
    } else if (user?.RoleId == "6") {
      setRoleNavigation(ConnectNavigations);
    } else {
      setRoleNavigation(navigation);
    }
  }, [user?.RoleId]);
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [anchorE2, setAnchorE2] = React.useState(null);

  const [menuItems, setMenuItems] = useState([]);

  const handleMenuClick = (event, items) => {
    setAnchorE2(event.currentTarget);
    setMenuItems(items);
  };

  const handleMenuClose = () => {
    setAnchorE2(null);
    setMenuItems([]);
  };
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClick2 = (event) => {
    setSubMenu(event.currentTarget);
  };

  const handleClose2 = () => {
    setSubMenu(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    setToken(null);
    setUser({
      FullName: "",
      Email: "",
      RoleId: "",
    });
    handleClose();
  };

  // const handleOutsideClick = (event) => {
  //   if (anchorEl && !anchorEl.contains(event.target)) {
  //     setAnchorEl(null);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("mousedown", handleOutsideClick);
  //   return () => {
  //     document.removeEventListener("mousedown", handleOutsideClick);
  //   };
  // }, [anchorEl]);
  const primaryColor = "#0070C2";
  const activeBgColor = "rgba(255, 171, 44, 0.1)";
  const activeTextColor = primaryColor;
  const hoverBgColor = "rgba(255, 171, 44, 0.05)";
  const textColor = "black";
  const submenuBgColor = "#2f353d";

  const StyledMenu = styled((props) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color:
        theme.palette.mode === "light"
          ? "rgb(55, 65, 81)"
          : theme.palette.grey[300],
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& .MuiMenu-list": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  }));
  // linear-gradient(351deg, rgba(233,235,240,1) 45%, rgba(255,255,255,1) 71%)

  return (
    <header>
      <div
        className={`header-container border-b !border-gray-300 !m-0 !bg-white`}
        style={{
          backgroundColor: "#373d45",
        }}
      >
        <div className={`header`}>
          <div className="flex gap-3">
            <div
              className="flex xl:hidden cursor-pointer  items-center"
              onClick={() => setToggle(!toggle)}
            >
              <CgMenuLeftAlt className="!text-primary text-5xl " />
            </div>
            <div className="w-10 xl: hidden lg:w-12">
              <img src="/images/hassllogo.png" alt="logo" className="w-full" />
            </div>
          </div>
          <nav className="header-nav hidden xl:flex flex-1 min-w-0 items-center !gap-1 overflow-x-auto no-scrollbar mx-2">
            {Array.isArray(subNav) && subNav.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flexWrap: "nowrap",
                  whiteSpace: "nowrap",
                  gap: 0.25,
                  py: 0.5,
                  px: 0.5,
                }}
              >
                {subNav?.map((item, i) => {
                  const itemFullPath = item?.path?.startsWith("/") ? item?.path : `/${item?.path}`;
                  const isActive =
                    location?.pathname === itemFullPath ||
                    location?.pathname.substring(1) === item?.path ||
                    (item?.path === "claims/bulk-replace" &&
                      (location?.pathname.includes("diagnosis-bulk-replace") ||
                        location?.pathname.includes("item-bulk-replace")));
                  const IconComponent = iconMap[item?.icon];

                  return (
                    <Button
                      className="group"
                      key={`${item?.path}-${i}`}
                      onClick={() => navigate(itemFullPath)}
                      startIcon={
                        IconComponent ? (
                          <IconComponent
                            sx={{
                              fontSize: "1rem",
                              color: isActive ? "#0070C2" : "#000000b3",
                              ...(i18n.language === "ar" && {
                                marginLeft: "8px !important",
                                marginRight: "-2px !important",
                              }),
                              ...(i18n.language === "en" && {
                                marginRight: "0px !important",
                              }),
                            }}
                          />
                        ) : null
                      }
                      sx={{
                        justifyContent: "flex-start",
                        px: 1.25,
                        py: 0.5,
                        minHeight: 34,
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                        textTransform: "none",
                        fontSize: "0.85rem",
                        color: isActive ? "#0070C2" : "#000000b3",
                        backgroundColor: isActive
                          ? "rgba(25, 118, 210, 0.08)"
                          : "transparent",
                        fontWeight: isActive ? 600 : 500,
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "rgba(25, 118, 210, 0.08)",
                        },
                        transition: "all 0.15s ease",
                        lineHeight: 1.2,
                      }}
                    >
                      {/* <img
                        src="/images/supergit-03.png"
                        alt="logo"
                        className="h-14 w-14"
                        // style={{ width: "100%", objectFit: "contain" }}
                      /> */}
                      <Typography
                        variant="caption"
                        sx={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          fontSize: "0.8rem",
                          fontWeight: "inherit",
                          color: "#4b5563",
                        }}
                      >
                        {t(item?.name)}
                      </Typography>
                    </Button>
                  );
                })}
              </Box>
            )}

            <StyledMenu
              id="simple-menu"
              anchorEl={anchorE2}
              keepMounted
              open={Boolean(anchorE2)}
              onClose={handleMenuClose}
            >
              {menuItems.map((menuItem, index) => (
                <MenuItem
                  key={index}
                  onClick={() => {
                    navigate(menuItem.path);
                    handleMenuClose();
                    setToggle(false);
                  }}
                >
                  {menuItem?.icon && <menuItem.icon />}
                  {t(menuItem.name)}
                </MenuItem>
              ))}
            </StyledMenu>
          </nav>

          <div
            className={`overlay ${toggle ? "show" : ""}`}
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
          >
            <div
              className={`sidebar ${toggle ? "open" : ""
                } !p-0 !bg-[#0070C2] !w-[230px] flex flex-col`}
            >
              {/* Header with Logo */}
              <div className="flex justify-between items-center p-[15px] border-b border-white/10">
                <img
                  src="/images/supergit-4.0.png"
                  alt="logo"
                  className="h-8 max-w-[150px] object-contain"
                />
                <div
                  className="cursor-pointer h-8 w-8 rounded-full flex justify-center items-center text-white hover:bg-white/10 transition-colors"
                  onClick={() => setToggle(false)}
                >
                  <IoClose className="text-2xl" />
                </div>
              </div>

              {/* Navigation List */}
              <nav className="mt-2 flex-1 overflow-y-auto">
                <ul className="list-none space-y-0 p-0 m-0">
                  {roleNavigation.map((nav, index) => {
                    const isActive =
                      (nav.menu &&
                        nav.menu.some((item) =>
                          location.pathname.includes(item.path),
                        )) ||
                      location.pathname.includes(nav.path);

                    const IconComponent = nav.icon;

                    return (
                      <li key={index}>
                        <NavLink
                          to={nav.path}
                          onClick={(event) => {
                            if (nav.menu && nav.menu.length > 0) {
                              event.preventDefault();
                              handleMenuClick(event, nav.menu);
                            } else {
                              setActive(nav.name);
                              setToggle(false);
                            }
                          }}
                          className={classNames(
                            "flex items-center gap-2 px-2.5 py-2 transition-all duration-200 no-underline group",
                            isActive
                              ? "bg-[#1faae8] !text-white"
                              : "hover:bg-white/10 !text-white",
                          )}
                        >
                          {/* Icon Container */}
                          <div
                            className={classNames(
                              "w-[28px] h-[28px] rounded-full flex items-center justify-center border transition-all shrink-0",
                              isActive
                                ? "border-white bg-white text-[#0070C2]"
                                : "border-white text-white bg-transparent group-hover:bg-white group-hover:text-[#0070C2]",
                            )}
                          >
                            {IconComponent && (
                              <IconComponent className="!text-[15px]" />
                            )}
                          </div>

                          {/* Text */}
                          <span
                            className={classNames(
                              "font-medium text-[0.875rem] leading-none",
                              isActive
                                ? "text-white font-semibold"
                                : "text-white",
                            )}
                          >
                            {t(nav.name)}
                          </span>

                          {/* Dropdown Indicator */}
                          {nav.menu && nav.menu.length > 0 && (
                            <IoMdArrowDropdown
                              className={classNames(
                                "ml-auto text-xl",
                                "text-white",
                                i18n.language === "ar"
                                  ? "mr-auto ml-0 rotate-90"
                                  : "",
                              )}
                            />
                          )}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </div>
          </div>
          <div className="user-info shrink-0 bg-white z-10 pl-2 flex gap-1 items-center justify-end ml-auto mr-0">
            {/* <ClickAwayListener onClickAway={handleClose}> */}
            <LanguageSwitcher />
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              size="small"
            >
              <div className="">
                <div className="flex items-center gap-2 bg-blue-50  transition-all duration-300 rounded-lg pl-3 pr-4 py-1">
                  <Avatar
                    className="uppercase"
                    sx={{
                      width: 28,
                      height: 28,
                      fontSize: "0.7rem",
                      backgroundColor: "#0070C2",
                    }}
                    style={{ color: "#ffffff" }}
                  >
                    {user?.FullName ? user?.FullName.charAt(0) : "S"}
                  </Avatar>

                  <div className="flex flex-col leading-tight">
                    <span className="text-gray-700 font-semibold text-[12px]">
                      {user?.FullName ? user?.FullName : "User"}
                    </span>
                    <span className="text-gray-500 text-[11px] text-left">
                      {user?.RoleName}
                    </span>
                  </div>
                </div>
              </div>
            </Button>
            {users?.length > 0 && (
              <Button
                title="Switch User"
                id="switch-user-button"
                aria-controls={subMenu ? "user-switch-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={subMenu ? "true" : undefined}
                onClick={handleClick2}
                size="small"
                className={`!bg-gray-100 !h-[30px] !w-[30px] flex items-center justify-center !text-white !border-none !p-0 !hover:!bg-transparent !hover:!text-white ${i18n.language == "ar" ? "!ml-2" : "!mr-2"
                  }`}
              >
                <FaExchangeAlt className="text-gray-700" size={20} />
              </Button>
            )}
            <StyledMenu
              id="basic-menu"
              anchorEl={subMenu ? subMenu : undefined}
              open={Boolean(subMenu)}
              onClose={handleClose2}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              PaperProps={{
                style: {
                  marginTop: "8px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  borderRadius: "4px",
                  minWidth: "200px",
                  border: "1px solid #e0e0e0",
                },
              }}
            >
              {users?.map((user, index) => (
                <MenuItem
                  disabled={changeLoading}
                  key={index}
                  onClick={async () => {
                    setChangeLoading(true);
                    try {
                      const response = await axios.post(
                        "https://api.supergitsa.com/api/changeUser",
                        {
                          unique_key: user?.unique_key,
                        },
                        {
                          headers: {
                            Authorization: `Bearer ${tokenWithoutQuotes}`,
                          },
                        },
                      );
                      const data = response.data;
                      console.log(data);
                      if (data?.status == 200) {
                        setToken(data.data.jwt);
                        localStorage.setItem(
                          "token",
                          JSON.stringify(data.data.jwt),
                        );

                        setPermissions(parsePermissions(data.data.permission));
                        localStorage.setItem(
                          "permissions",
                          JSON.stringify(
                            parsePermissions(data.data.permission),
                          ),
                        );

                        let user = {
                          FullName: data.data.full_name,
                          Email: data.data.email,
                          RoleId: data.data.role_id,
                          RoleName: data.data.role_name,
                        };
                        setUser(user);
                        localStorage.setItem("user", JSON.stringify(user));
                        window.location.reload();
                        handleClose2();
                      } else {
                        toast.error(data?.message);
                      }
                    } catch (error) {
                      console.log(error);
                    } finally {
                      setChangeLoading(false);
                    }
                  }}
                  style={{
                    fontSize: "14px",
                    padding: "8px 16px",
                    fontStyle: "normal",
                    borderBottom: "1px solid #f0f0f0",
                    lineHeight: "1.5",
                  }}
                >
                  {user?.user_detail?.users_full_name || ""}
                </MenuItem>
              ))}
            </StyledMenu>
            <StyledMenu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem>
                <div className="!border-b-2 pb-2  !border-[#242429]">
                  <div className="!text-[#242429] !text-[18px] !font-medium !not-italic !leading-none !flex !items-center !pb-[3px]">
                    {user?.FullName}
                  </div>
                  <div>
                    <div className="!text-[#4d4d53] !text-[15px] !font-normal mt-1 !not-italic !leading-none">
                      {user?.RoleName}
                    </div>
                  </div>
                </div>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/physicians");
                  handleClose();
                }}
              >
                <Person2Rounded
                  className={`${i18n.language == "ar" ? "!ml-2" : "!mr-2"}`}
                />{" "}
                {t("Physicians")}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("/price-list");
                  handleClose();
                }}
              >
                <ListAlt
                  className={`${i18n.language == "ar" ? "!ml-2" : "!mr-2"}`}
                />{" "}
                {t("Price List")}
              </MenuItem>
              {user?.RoleId === "12" && (
                <MenuItem
                  onClick={() => {
                    navigate("/icd-codes");
                    handleClose();
                  }}
                >
                  <ListAlt
                    className={`${i18n.language == "ar" ? "!ml-2" : "!mr-2"}`}
                  />{" "}
                  {t("ICD Codes")}
                </MenuItem>
              )}
              {user?.RoleId === "12" && (
                <MenuItem
                  onClick={() => {
                    navigate("/sfda-medicine");
                    handleClose();
                  }}
                >
                  <MedicalServices
                    className={`${i18n.language == "ar" ? "!ml-2" : "!mr-2"}`}
                  />{" "}
                  {t("SFDA Medicine")}
                </MenuItem>
              )}

              <MenuItem
                onClick={() => {
                  handleLogout();
                }}
                style={{ color: "red", fontWeight: "bold" }}
              >
                <LogoutRounded
                  className={`${i18n.language == "ar" ? "!ml-2" : "!mr-2"}`}
                />{" "}
                {t("Logout")}
              </MenuItem>
            </StyledMenu>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
